import React, { useState } from "react";
import { Button } from "/src/modern/components/ui/button";
import { Card, CardContent } from "/src/modern/components/ui/card";
import { TooltipProvider, } from "/src/modern/components/ui/tooltip";
import { MessageDialog } from "@bryntum/schedulerpro";
import { getDemoBoardsList, duplicateBoardAndTestDrive } from "../../../network/network.jsx";
import { showToast, serverErrorMsg } from "../../../other/utils/utils.jsx";
import { ASYNC_TASK_TYPES } from "@/other/constants/OtherKeys.jsx";
import { useAsyncTaskContext } from "@/modern/components/async-tasks/context/AsyncTaskContext";
import { extractAsyncTaskId } from "@/modern/components/async-tasks/utils";

export function TemplateCard(props) {
  const {
    title,
    description,
  } = props;

  const [isHovered, setIsHovered] = useState(false);
  const { pinTask } = useAsyncTaskContext();

  const handleUseTemplate = async () => {
    try {
      // Generate a random number for the default test drive name
      const randomNumber = Math.floor(1000 + Math.random() * 9000);
      const defaultName = `${title} ${randomNumber}`;

      const result = await MessageDialog.prompt({
        title: "Personalize your Test Drive",
        message: "Enter a custom name for your Test Drive",
        textField: { value: defaultName },
        okButton: { text: "Create Test Drive" }
      });

      if (result.button === MessageDialog.okButton) {
        const { data } = await getDemoBoardsList();
        if (data.length) {
          const demoBoard = data[0];
          const response = await duplicateBoardAndTestDrive(
            demoBoard.id,
            result.text,
            ["everything"],
            { test_drive: true },
          );
          const taskId = extractAsyncTaskId(response.data);
          if (taskId == null) {
            MessageDialog.alert({
              title: "Test Drive Failed",
              message: "The server did not return a task id. Please try again.",
            });
            return;
          }
          pinTask(taskId, {
            type: ASYNC_TASK_TYPES.DEMO_BOARD_CREATION,
            meta_data: { board_name: result.text },
          });
        }
      }
    } catch (error) {
      showToast({ msg: error?.response?.data || serverErrorMsg(), type: "error" });
    }
  };

  return (
    <TooltipProvider>
      <Card
        className={`transition-all duration-300 ease-in-out h-full hover:scale-[1.02] bg-card ${
          isHovered
            ? "shadow-lg"
            : "shadow-sm"
        }`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <CardContent className="!p-swivu-base">
          {/* Header */}
          <div className="flex justify-between">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-4 mb-swivu-base">
                <h3 className="text-lg font-semibold overflow-hidden text-ellipsis whitespace-nowrap text-foreground">
                  {title}
                </h3>
              </div>

              {/* Description */}
              <p dangerouslySetInnerHTML={{ __html: description }} className="text-swivu-sm text-muted-foreground mt-0 mb-swivu-base"></p>
            </div>
          </div>

          {/* Template Image */}
          <div className="mb-4 rounded-lg overflow-hidden bg-muted flex items-center justify-center">
            <img
              src="/assets/cucumber-construction.png"
              alt="Template Preview"
              className="aspect-video"
            />
          </div>

          {/* Button */}
          <Button
            size="sm"
            className="w-full bg-purple-600 hover:bg-purple-700 text-white border-purple-500"
            onClick={handleUseTemplate}
          >
            <i className="fa-solid fa-wand-magic-sparkles mr-2"></i>
            Use Template
          </Button>
        </CardContent>
      </Card>
    </TooltipProvider>
  );
}
